import { JobRequirement } from '../../../store/rtk-query/apis/position/dto/response/position.response';

export const SKIP_ITEM_ID = 'SKIP_ID';

export const getUserInputsJobRequirement = (jobRequirements: PositionJobRequirementState[]): JobRequirement[] => (
  jobRequirements
    ?.filter((jobRequirement) => jobRequirement.id !== SKIP_ITEM_ID && !!jobRequirement.title)
    .map((jobRequirement: PositionJobRequirementState) => ({
      id: jobRequirement.id,
      value: jobRequirement.title,
    })) || []
);

export const getDegrees = (degrees: PositionJobRequirementState[]): string[] => (
  degrees?.reduce((acc: string[], degree: PositionJobRequirementState) => {
    if (degree.selected && degree.id) {
      acc.push(degree.id);
    }

    return acc;
  }, [])
);

type SuggestionFieldsOfStudy = {
  value: string
}
export const getSuggestionFieldsOfStudy = (suggestedFieldsOfStudy: PositionJobRequirementState[]): SuggestionFieldsOfStudy[] => (
  suggestedFieldsOfStudy?.reduce((acc: SuggestionFieldsOfStudy[], fieldsOfStudy: PositionJobRequirementState) => {
    if (fieldsOfStudy.selected && fieldsOfStudy.id) {
      acc.push({
        value: fieldsOfStudy.id,
      });
    }

    return acc;
  }, []) || []
);
